module.exports = __webpack_public_path__ + "static/media/da-ct-scan-3.57f1e36d.jpg";